<template>
  <div class="container">
    <div class="pa-t-40 bg-fff">
      <div class="t-center c-fff fon-26 c-red font-bold">提交成功，微信扫码领取电子票</div>
      <div class="t-center ma-t-20">作为入场凭证</div>
      <div class="qr-wrap t-center">
        <img src="../../img/qrcode.png" alt="" srcset="" class="ma-r-20">
        <div>主办方审核通过后电子票自动生效，<br>
        审核结果可在电子票中查看。  </div>
      </div>
      <div class="pa-30 flex f-jcenter f-center ma-t-30">
            <div class="font-bold">分享到：</div>
            <div class="flex f-jcenter">
              <div class="share-icon" @click="copyToClip()" title="复制链接">
                <i class="iconfont icon-lianjie"></i>
              </div>
              <div class="share-icon ma-lr-20" @click="shareQQ()" title="分享到QQ空间">
                <i class="iconfont icon-qqkongjian"></i>
              </div>
              <div class="share-icon" @click="shareWEB()" title="分享到微博">
                <i class="iconfont icon-weibo"></i>
              </div>
            </div>
          </div>
    </div>
  </div>
</template>

<script>
import { getCrowdFundingDetail } from "../../api.js";
export default {
  data() {
    return {
      amountData: {},
      projectData:{},
      amountId:'',
      projectId:'',

      Amount:'',//支持金额
    };
  },
  activated() {
    if(this.$route.query.amountId!=this.amountId || this.$route.query.projectId!=this.projectId){
        this.projectId = this.$route.query.projectId;

    }
    
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },
  methods: {
    //获取众筹信息
    loadData(){
        getCrowdFundingDetail({id: this.projectId}).then(res=>{
            this.projectData = res.data.Data;
            this.amountData= this.projectData.AmountList.find(item=>{
                if(item.Id==this.amountId){
                    return item
                }
            })
        })
    },
  },
};
</script>

<style  lang="scss" scoped>

.share-icon {
  width: 40px;
  height: 40px;
  background: #8a8a8a;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  color: #fff;
  cursor: pointer;
}
.bg-red {
  background: #fb004d;
}

.qr-wrap {
  img {
    width: 200px;
  }
}
</style>